import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {EditarPolizaMadreComponent} from '../editar-poliza-madre/editar-poliza-madre.component';

@Component({
  selector: 'lista-modal-editar',
  templateUrl: './lista-modal-editar.component.html',
})
export class ListaModalEditar implements OnInit {
  isCountries: false;
  title: string;
  list: any;

    constructor(
        public dialogRef: MatDialogRef<EditarPolizaMadreComponent>,
        @Inject(MAT_DIALOG_DATA) public data,
    ) {}

    ngOnInit(): void {
        this.title = this.data.title;
      this.list = this.data.list;
      this.isCountries = this.data.isCountries;
    }

    onNoClick(result): void {
        this.dialogRef.close(result);
    }
}
